export function isNullish(v: any): v is null | undefined {
    return v == null
}
